/**
 * Created by Carsten Bühler
 * User: c.buehler on 11.03.2019
 * Copyright: xdot GmbH 2019
 */
import React from 'external/react';
import PropTypes from 'external/prop-types';
import {  DataUtil, AppContext, ContextContainer } from 'plugin/liferay-widgets-react-web';
import ReferenceValueActions from '../actions/ReferenceValueActions';
import { getReferenceValueStore } from '../stores/StoreFactory';

import {  FormControl, } from 'external/react-bootstrap';

const ReferenceValueStore = getReferenceValueStore(AppContext);

class ReferenceValueSelect extends React.Component {

    constructor(props) {
        super(props);
        this.DATA = {
            REFERENCE_VALUES: 'RefValues'
        };

        this.onSelect = this.onSelect.bind(this);
    }

    static getStores() {
        return [
            ReferenceValueStore
        ];
    }

    static calculateState(prevState, undefined, DATA) {
        return {
            referenceValues: ReferenceValueStore.getRemoteData(DATA.REFERENCE_VALUES)
        };
    }

    componentDidMount() {
        if (this.props.id>0) {
            ReferenceValueActions.getReferenceValuesByDataTypeNotExpired(this.DATA.REFERENCE_VALUES, {
                className: this.props.className,
                classPK: this.props.id,
                dataType: this.props.dataType
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.id !== prevProps.id || this.props.className !== prevProps.className || this.props.dataType !== prevProps.dataType) {
            if (this.props.id===-1){
                ReferenceValueActions.remove();
            } else {
                ReferenceValueActions.getReferenceValuesByDataTypeNotExpired(this.DATA.REFERENCE_VALUES, {
                    className: this.props.className,
                    classPK: this.props.id,
                    dataType: this.props.dataType
                });
            }

        }
    }

    onSelect(e) {
        let referenceValue = undefined;
        if (e.target.value.indexOf('-') > 0) {
            const refKey = e.target.value.split('-');
            referenceValue = DataUtil.asArray(this.state.referenceValues).find(refVal => refVal.key===refKey[0] && refVal.unit===refKey[1] && refVal.dataType===refKey[2]);
        }

        this.props.onChange(referenceValue);
    }

    render() {
        let refKeyOptions = [];
        const referenceValues = DataUtil.asArray(this.state.referenceValues);
        if (referenceValues && referenceValues.length > 0){
            refKeyOptions = [<option key={-1} value={"--"}>Bitte auswählen</option>];
            if (this.props.filterFn){
                refKeyOptions = refKeyOptions.concat(referenceValues.filter(this.props.filterFn).map(refValue => <option key={refValue.id} value={refValue.key+'-'+refValue.unit+'-'+refValue.dataType}>{this.refLabel(refValue)}</option>))
            } else {
                refKeyOptions = refKeyOptions.concat(referenceValues.map(refValue => <option key={refValue.id} value={refValue.key+'-'+refValue.unit+'-'+refValue.dataType}>{this.refLabel(refValue)}</option>))
            }

        } else {
            refKeyOptions = [<option key={-1} value={null}>Keine Kennwerte vorhanden!</option>];
        }

        const refKey = this.props.refKey+'-'+this.props.unit+'-'+this.props.dataType;

        return (<FormControl as="select"
                     label="Kennwert"
                     value={refKey}
                     onChange={this.onSelect}>
            {}
            {refKeyOptions}
        </FormControl>);
    }

    refLabel(refValue){
        return refValue.title + ' (' + refValue.value + ' ' + refValue.unit.replace("m3/s", "m³/s") + ')';
    }
}


ReferenceValueSelect.propTypes = {
    onChange: PropTypes.func.isRequired,

    className: PropTypes.string,
    id: PropTypes.number,
    dataType: PropTypes.string,
    refKey: PropTypes.string,
    unit: PropTypes.string,
    filterFn: PropTypes.func
};

export default ContextContainer.create(ReferenceValueSelect);



// WEBPACK FOOTER //
// ./js/components/ReferenceValueSelect.jsx